import { mapGetters } from "vuex";
import * as BOOKING_GETTER from "../../../../../store/booking/getter-types";

export default {
  computed: {
    ...mapGetters({
      booking: BOOKING_GETTER.GET_BOOKING,
      reservation: BOOKING_GETTER.GET_RESERVATION,
      totalPrice: BOOKING_GETTER.GET_BOOKING_TOTAL_PRICE,
      travellersTotal: BOOKING_GETTER.GET_BOOKING_TRAVELLERS_TOTAL
    }),
    redsysParams() {
      return this.$route.query.redsys && JSON.parse(this.$route.query.redsys) || null;
    }
  }
};
